import axiosInstance from "utils/axios";

async function apiGetData(url, params, signal) {
    return axiosInstance.get(url, { params, signal });
}

async function axiosApiCalling(data) {
    return axiosInstance.request(data);
}

async function apiPostData(url, data = {}) {
    const formData = new FormData();
    Object.entries(data).forEach(([key, value]) => formData.append(key, value));
    return axiosInstance.post(url, formData);
}
async function apiPostDataJson(url, data = {}) {
    return axiosInstance.post(url, data, {
        headers: {
            'Content-Type': 'application/json'
        }
    });
}


export { axiosApiCalling, apiGetData, apiPostData, apiPostDataJson };
